<template>
    <div class="all addDate">
        <div class="warp mt20" style="padding-bottom:20px;">
            <div class="warp-header d-flex justify-between">
                <h2>用户管理</h2>
                <div class="addData curp" @click="addData(null)">新增用户</div>
            </div>
            <div class="warp-body clearfix minheight">
                <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="18%">
                        <col width="18%">
                        <col width="17%">
                        <col width="18%">
                        <col width="17%">
                        <col width="12%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>用户名</th>
                            <th>手机号</th>
                            <th>昵称</th>
                            <th>密码</th>
                            <th>状态</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in dataList" :key="index">
                            <td>{{item.username}}</td>
                            <td>{{item.tel}}</td>
                            <td>{{item.nickname}}</td>
                            <td>{{item.originalPassword}}</td>
                            <td>
                                <div class="table-all-icons">
                                    <span v-if="item.status == '0'" class="status2">禁止</span>
                                    <span v-else-if="item.status =='1'" class="status1">正常</span>
                                </div>
                            </td>
                            <td>
                                <div class="table-all-icons">
                                    <span class="curp color-blue" @click="addData(item)">编辑</span>
                                    <span class="curp color-red pl5" @click="delateUser(item.id)">删除</span>
                                    <span class="curp color-orange pl5" @click="openRoot(item.id)">权限</span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- 分页 -->
            <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
        </div>
        <!-- 新增用户 -->
        <Dialog ref="addDataModal" type="normal" width="500" :title="title" :callback="sureAdd">
            <div slot="mdBox" >
                <div class="d-flex">
                    <div class="title__"><span class="color-red">*</span>用户名:</div>
                    <el-input v-model="username" placeholder="请输入"></el-input>
                </div>
                <div class="d-flex mt20">
                    <div class="title__"><span class="color-red">*</span>手机号:</div>
                    <el-input v-model="tel" placeholder="请输入"></el-input>
                </div>
                <div class="d-flex mt20">
                    <div class="title__"><span class="color-red">*</span>昵称:</div>
                    <el-input v-model="nickname" placeholder="请输入"></el-input>
                </div>
                <div class="d-flex mt20">
                    <div class="title__"><span class="color-red">*</span>密码:</div>
                    <el-input v-model="password" type="password" placeholder="请输入"></el-input>
                </div>
                <div class="d-flex mt20">
                    <div class="title__">状态:</div>
                    <div class="fr mt10">
                        <span class="switch" :class="status? 'active' : ''" @click="oneButtonSwitch();"><i class="icons switch-icon"></i></span>
                        <span v-if="!status">禁用</span><span v-else>正常</span>
                    </div>
                </div>
            </div>
        </Dialog>
        <!-- 权限 -->
        <Dialog ref="rootModal" type="normal" width="500" title="权限管理" :callback="sureRoot">
            <div slot="mdBox" >
                <div class="item clearfix" v-if="schemeList&&schemeList.length>0">
                    <div class="name fl" style="margin-top:5px;margin-right:10px;">方案列表:</div>
                    <div class="input-father checkbox-group">
                        <label class="checkbox-box" v-for="(item,index) in schemeList" :key="index">
                            <label class="checkbox-warp fl" :class="schem.indexOf(item.name)  != -1? 'curr' : ''"><input name="" v-model="schem" type="checkbox" :value="item.name" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                            <div class="hidden ac textover" :title="item.name">{{item.name}}</div>
                        </label>
                    </div>
                </div>
                <div class="item clearfix mt20" v-if="customFollowInfoSourceList&&customFollowInfoSourceList.length>0">
                    <div class="name fl" style="margin-top:5px;margin-right:10px;">信源列表:</div>
                    <div class="input-father checkbox-group">
                        <label class="checkbox-box" v-for="(item,index) in customFollowInfoSourceList" :key="index">
                            <label class="checkbox-warp fl" :class="custom.indexOf(item.name)  != -1? 'curr' : ''"><input name="" v-model="custom" type="checkbox" :value="item.name" class="checkbox"> <i class="icons checkbox-icon"></i></label>
                            <div class="hidden ac textover" :title="item.name">{{item.name}}</div>
                        </label>
                    </div>
                </div>
            </div>
        </Dialog>
        <Dialog ref="delateModal" type="normal" width="400" title="提示" :callback="sureDelate">
            <div slot="mdBox" >
                <div>确认删除此用户吗？</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Dialog from '../../components/dialog.vue';
import page from '../../components/page.vue';
export default {
    components:{Dialog,page},
    data() {
        return {
            title:'新增用户',
            dataList:[
                {
                   status:0,
                   source_url:'',
                   addtime:''
                }
            ],
            url:'',
            id:'',
            status:false,
            username:'',
            tel:'',
            nickname:'',
            password:'',
            schem:[],
            custom:[],
            schemeList:[],
            customFollowInfoSourceList:[],
            page:1,//页码
            limit:20,//每页显示条数
            totalCount:'',//总页数
        }
    },
    watch:{
        schem:{
            handler(nval,oval){
                console.log(nval);
            }
        },
        custom:{
            handler(nval,oval){
                console.log(nval)
            }
        },
        schemeList:{
            handler(nval,oval){
                for(let item of nval){
                    if(item.checked == 1){
                        this.schem.push(item.name);
                    }
                }
            }
        },
        customFollowInfoSourceList:{
            handler(nval,oval){
                for(let item of nval){
                    if(item.checked == 1){
                        this.custom.push(item.name);
                    }
                }
            }
        }
    },
    mounted() {
        this.getdataList();
    },
    created() {
		
    },
    methods: {
        //删除用户
        delateUser(id){
            this.id = id;
            this.$refs.delateModal.showMaskFun();  
        },
        //确认删除
        sureDelate(){
            let ids = [],that = this;
            ids.push(this.id);
            let parms = {
                ids:ids
            }
            console.log(ids)
            that.$parent.loadModal(true,'正在删除。。。');
            that.$api.post('user/user/del',parms,r =>{
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('删除成功');
                    that.$refs.delateModal.closeMask();  
                    that.getdataList();
                })
                that.$parent.showLoad = false;
            })
        },
        //
        addData(item){
            if(item){
                this.title = '编辑用户'
                this.username = item.username;
                this.nickname = item.nickname;
                this.status = item.status == 1?true:false;
                this.tel = item.tel;
                this.id = item.id;
                this.password = item.originalPassword;
            }else{
                this.title = '新增用户';
                this.username = '';
                this.nickname = '';
                this.status = false;
                this.tel = '';
                this.id = '';
                this.password = '';
            }
            this.$refs.addDataModal.showMaskFun();  
        },
        // 获取
        getdataList (){
            let that = this;
            let parms = {
                page:this.page,
                perpage:this.limit
            }
            that.$api.get('user/user/list',parms,r =>{
                that.$utils.returnCode(r,function(){
                    that.dataList = r.data.list;
                    that.totalCount = Number(r.data.count);
                })
            })
        },
         getTableData () {
            this.getdataList();
        },
        //确认添加
        sureAdd(){
            let that = this;
            if(this.username.length==0){
                that.$utils.alertText('请填写用户名');
                return false;
            }
            if(this.nickname.length==0){
                that.$utils.alertText('请填写昵称');
                return false;
            }
            if(this.tel.length==0){
                that.$utils.alertText('请填写手机号');
                return false;
            }
            if(this.password.length==0){
                that.$utils.alertText('请填写密码');
                return false;
            }
            let parms = {
                id:this.id,
                username:this.username,
                nickname:this.nickname,
                tel:this.tel,
                password:this.password,
                status:this.status?1:0
            }
            that.$parent.loadModal(true,'正在保存中。。。');
            that.$api.post('user/user/save',parms,r =>{
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('保存成功');
                    that.$refs.addDataModal.closeMask();  
                    that.getdataList();
                })
                that.$parent.showLoad = false;
            })
        },
        oneButtonSwitch(){
            this.status = !this.status;
        },
        //修改权限
        openRoot(id){
            this.id = id;
            this.schem = [];
            this.custom = [];
            this.$refs.rootModal.showMaskFun();
            let that = this;
            //权限列表
            that.$api.get('user/user/user-authority',{id:id},r =>{
                that.$utils.returnCode(r,function(){
                    that.schemeList = r.data.schemeList;
                    that.customFollowInfoSourceList = r.data.customFollowInfoSourceList;
                })
            })
        },
        //确认修改
        sureRoot(){
            for(let items of this.schemeList){
                items.checked = -1;
            }
            for(let item of this.schem){
                for(let items of this.schemeList){
                    if(item == items.name){
                        items.checked = 1;
                    }
                }
            }
            for(let items of this.customFollowInfoSourceList){
                items.checked = -1;
            }
            for(let item of this.custom){
                for(let items of this.customFollowInfoSourceList){
                    if(item == items.name){
                        items.checked = 1;
                    }
                }
            }
            let that = this;
            let parms = {
                id:this.id,
                schemeList:this.schemeList,
                customFollowInfoSourceList:this.customFollowInfoSourceList,
            }
            that.$parent.loadModal(true,'正在保存中。。。');
            that.$api.post('user/user/save-user-authority',parms,r =>{
                that.$utils.returnCode(r,function(){
                    that.$utils.alertText('保存成功');
                    that.schem = [];
                    that.custom = [];
                    that.$refs.addDataModal.closeMask();
                    that.$refs.rootModal.closeMask();
                      
                })
                that.$parent.showLoad = false;
            })
        }
	}
}
</script>
<style scope>
    .title__{
        width: 80px !important;
    }
    .textover{
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/page/personalCenter/userManage.vue